// Live URLs
export const LINKS = {
  // Strategy call calendar
  calendar: "https://api.leadconnectorhq.com/widget/bookings/advisor-funnel",
  // Free lead magnet
  leadMagnet: "https://stan.store/ZivaeFinancial/p/the-financial-advisor-content-kit",

  // START HERE — entry tools
  digitalIncomeAssessment: "https://stan.store/ZivaeFinancial/p/digital-income-mastery-questionnaire",
  digitalIncomeBlueprint: "https://stan.store/ZivaeFinancial/p/starting-your-first-online-business",

  // MARKETING ADD-ONS
  contentMarketingGuide: "https://stan.store/ZivaeFinancial/p/a-beginners-guide-to-content-marketing-wkn4a",
  digitalMarketerFinancialPlan: "https://stan.store/ZivaeFinancial/p/a-digital-marketers-financial-plan",
  emailListFast: "https://stan.store/ZivaeFinancial/p/build-your-email-list-fast",

  // ADVISOR AUTOMATION PACKAGES (Stan Store)
  starterSetup: "https://stan.store/ZivaeFinancial/p/starter-automation-setup",
  basicSetup: "https://stan.store/ZivaeFinancial/p/basic-package-tjeyhwxr",
  thanosSetup: "https://stan.store/ZivaeFinancial/p/the-thanos-package",
};

// Cinematic ad campaign visuals (served locally from /public/assets to avoid external host dependency)
export const CAMPAIGN_IMAGES = {
  fourAM: "/assets/4am-worry.png",
  chaseIsOver: "/assets/chase-is-over.png",
  roadrunner: "/assets/roadrunner.png",
  noShowMonster: "/assets/no-show-monster.png",
  sinkingStrategy: "/assets/sinking-strategy.png",
};
